class LoyaltyPoints extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('.product__info-container') || document;
    this.targets = this.querySelectorAll('[data-loyalty-points]');
    if (!this.targets.length) return;

    this.observer = new MutationObserver(() => this.render());
    this.scope.querySelectorAll('.price__wrapper').forEach((wrapper) => {
      this.observer.observe(wrapper, { childList: true, subtree: true, characterData: true });
    });

    this.render();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  render() {
    const points = this.getPoints();
    if (points === null) return;

    this.targets.forEach((target) => {
      target.textContent = points;
    });
  }

  getPoints() {
    const priceElement = Array.from(this.scope.querySelectorAll('.product__price')).find(
      (node) => node.textContent.trim() !== ''
    );
    if (!priceElement) return null;

    return LoyaltyPoints.wholeAmount(priceElement.textContent);
  }

  // One point per currency unit, so only the digits before the decimals count
  static wholeAmount(text) {
    const match = text.replace(/\s/g, '').match(/[\d.,]+/);
    if (!match) return null;

    const amount = match[0];
    const separator = Math.max(amount.lastIndexOf('.'), amount.lastIndexOf(','));
    // A trailing group of 3 digits is a thousands group, not decimals
    const hasDecimals = separator > -1 && amount.length - separator - 1 < 3;
    const whole = (hasDecimals ? amount.slice(0, separator) : amount).replace(/[.,]/g, '');
    if (whole === '') return null;

    return String(parseInt(whole, 10));
  }
}

if (!customElements.get('loyalty-points')) {
  customElements.define('loyalty-points', LoyaltyPoints);
}
